/**
 * @generated SignedSource<<4fdec9c973a11fa7fe29300f688a817b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type heroElementFragment$data = {
  readonly homePageTitle: string | null | undefined;
  readonly userLanguageTag: string | null | undefined;
  readonly visualConfig: {
    readonly foregroundColor: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "heroElementFragment";
};
export type heroElementFragment$key = {
  readonly " $data"?: heroElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "heroElementFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "homePageTitle"
    },
    {
      "kind": "ScalarField",
      "name": "userLanguageTag"
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "foregroundColor"
        }
      ]
    }
  ],
  "type": "HelpLayoutHeroElement"
};

(node as any).hash = "994a56f0bb806899b30ecbba62200689";

export default node;
